import React, { useState } from 'react';
import { cancelPayment } from '../api/paymentApi';

const CancelPaymentPage = () => {
  const [paymentId, setPaymentId] = useState('');
  const [reservationId, setReservationId] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // 결제 취소 요청
  const handleCancelPayment = async () => {
    setIsLoading(true);
    try {
      // Pass an object with both reservationId and paymentId
      const response = await cancelPayment({ reservationId, paymentId });
      setStatusMessage('결제가 취소되었습니다.');
    } catch (err: any) {
      setError(err?.message || '결제 취소에 실패했습니다.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="cancel-payment-container">
      <h2>결제 취소</h2>
      <div>
        <label>결제 ID</label>
        <input
          type="text"
          value={paymentId}
          onChange={(e) => setPaymentId(e.target.value)}
          placeholder="결제 ID"
        />
      </div>
      <div>
        <label>예약 ID</label>
        <input
          type="text"
          value={reservationId}
          onChange={(e) => setReservationId(e.target.value)}
          placeholder="예약 ID"
        />
      </div>
      <button onClick={handleCancelPayment} disabled={isLoading}>
        {isLoading ? '취소 중...' : '결제 취소'}
      </button>
      {statusMessage && <p>{statusMessage}</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
};

export default CancelPaymentPage;